<template>
    <div class="overflow-scroll py-3">
        <div class="w-full md:w-3/4 mx-auto mb-6">
            <input-image
                v-if="upload"
                :language="language"
                @uploaded="(file) => {
                    return media.unshift(file)
                }"
                label="Upload"
                :upload-route="uploadRoute"
            ></input-image>
        </div>

        <media-library :media-data="media" :editable="upload"/>
    </div>
</template>

<script>
import media from '../../mixins/media'
import siteLanguage from '../../config/siteLanguage'

export default {
    name: 'MediaLibraryPage',
    mixins: [media],
    props: {
        mediaData: Array,
        language: {
            type: Object,
            default: () => {
                return {iso: siteLanguage.iso.ENGLISH}
            },
        },
        upload: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            media: this.mediaData,
        }
    },
}
</script>
